import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Serializer} from '@paperlessio/sdk/api/serializers';
import {BucketType, ListableBucketParams, Token} from '@paperlessio/sdk/api/models'
import {Observable, throwError} from 'rxjs';
import {catchError, map} from 'rxjs/operators';
import * as Sentry from '@sentry/angular-ivy';
import {BaseServiceV1} from '@paperlessio/sdk/api/services';

@Injectable({providedIn: 'root'})
export class TokenService extends BaseServiceV1<Token> {
  constructor(http: HttpClient) {
    super(http);
    this.endpoint = 'tokens';
    this.serializer = new Serializer<Token>(Token);
  }

  allFromBucket(bucket_type: BucketType, bucket_id: number): Observable<Token[]> {
    const params: ListableBucketParams<Token> = {
      bucket_type,
      bucket_id,
      all: true
    };

    return this.fetch(params)
      .pipe(
        map(res => res.data.map(obj => this.serializer.fromJson(obj))),
        catchError(e => {
          Sentry.captureException(e);
          return throwError(e);
        })
      );
  }
}
